
import api from "@/api/index"; //ABP API接口
import { Vue, Component } from "vue-property-decorator";
import { ElementTableView } from "@/lib/ElementTableView";
import { MessageBox } from "element-ui";

import {ProjectDto, OrganizationUnitDto, AuditUserLogType} from "@/api/appService";

import AgileAuditTag from "@/components/AgileAuditTag/index.vue";
import EditProject from "./components/edit-project.vue";
import ProjectDetail from "@/views/projects/detail.vue";

import { getStore, removeStore } from "@/utils/storage";
import AuditFlowDetailButton from "@/components/AuditFlowDetailButton/index.vue";

@Component({
  name: "ProjectList",
  components: {
    AuditFlowDetailButton,
    EditProject,
    AgileAuditTag,
    ProjectDetail
  }
})
export default class ProjectList extends ElementTableView {
  tableItems: ProjectDto[] = [];

  projectDetailShow: boolean = false;

  projectDetail: any = {};

  async created() {
    await this.fetchData();
  }

  queryForm: any = {
    projectName: undefined,
    headmanName: undefined
  };

  // 获取表数据
  async fetchData() {
    this.table.listLoading = true;
    await api.project
      .getAll({
        projectName: this.queryForm.projectName,
        headmanName: this.queryForm.headmanName,
        sorting: this.table.sorting,
        skipCount: this.skipCount,
        maxResultCount: this.table.pagesize
      })
      .then(res => {
        console.log(res);
        this.table.listLoading = false;
        this.tableItems = res.items!;
        this.table.totalCount = res.totalCount!;
      });
  }

  get hostType(){
    return AuditUserLogType.Project;
  }

  // 新建
  handleCreate() {
    (this.$refs.editForm as any).show = true;
  }

  // 编辑
  handleEdit(index: number, row: any) {
    (this.$refs.editForm as any).show = true;
    (this.$refs.editForm as any).form = row;

    console.warn("%cu must reWrite this method", "color:#0048BA;");
  }
  handleDetail(index: number, row: any) {
    this.projectDetail = row;
    (this.$refs.projectDetail as any).show = true;
  }

  // 删除
  async handleDelete(index: number, row: ProjectDto) {
    this.$confirm("你确定删除吗?", "提示").then(async () => {
      await api.project
        .delete({
          id: row.id
        })
        .then(res => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.fetchData();
        });
    });
  }

  // 更新当前页
  async current_change(e: number) {
    this.table.page = e;
    await this.fetchData();
  }

  // Table排序
  async sort(e: any) {
    console.log("sort : ", e);
    if (e.prop && e.order) {
      this.table.sorting = `${e.prop} ${e.order}`;
    }
    await this.fetchData();
  }

  // 修改一页显示的条目
  async handleSizeChange(e: number) {
    this.table.pagesize = e;
    await this.fetchData();
  }

  // 搜索
  async handleSearch() {
    await this.fetchData();
  }

  // 重置搜索
  async handleResetSearch() {
    this.queryForm = {
      keyword: "",
      userName: "",
      from: undefined,
      to: undefined,
      isActive: undefined
    };
    await this.fetchData();
  }

  async handelOnSaved() {
    await this.fetchData();
  }

  // 显示详情
  jumpDetail(index: any, row: any) {
    var that = this;
    const id = row.id;
    this.$router.push({
      name: "projectsDetail",
      params: {
        id: id
      }
    });
  }

  //  提交审核
  async handleStartAudit(item: ProjectDto) {
    await api.project.startAudit({ body: item }).then(res => {
      this.$message.success("已提交");
      this.fetchData();
    });
  }

  // 项目收拨款
  handlePaymentsAndReceiptses(index:number, item:ProjectDto){

    this.$router.push({name:'paymentsAndReceiptsesList',params:{'id':item.id!.toString()}});
  }

  handleViewLedger(index:number, item:ProjectDto){
    this.$router.push({name:'ledgerList',params:{projectId:item.id!.toString()}})
  }

  // 菜单
  handleMenu($row: any) {
    switch ($row.type) {
      case "detail": {
        this.projectDetail = $row.item;
        (this.$refs.projectDetail as any).show = true;
        return;
      }
      case "startAudit": {
        this.handleStartAudit($row.item);
        return;
      }
      case "edit": {
        this.handleEdit($row.index, $row.item);
        return;
      }
      case "delete": {
        this.handleDelete($row.index, $row.item);
        return;
      }
    }
  }
}
